import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

/**
 * Processes the Emergent Google OAuth callback.
 * Reads session_id from URL fragment, exchanges it via backend, and redirects home.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUserDirect } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    api
      .post("/auth/google-callback", { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        setUserDirect(res.data);
        toast.success(`Welcome${res.data.name ? `, ${res.data.name.split(" ")[0]}` : ""}!`);
        // Clean URL and go to home (or wherever they should land)
        navigate("/", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-2 border-[#0066FF] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-slate-600 font-mono uppercase tracking-[0.2em]">Signing you in…</p>
      </div>
    </div>
  );
}
